module.exports = __webpack_public_path__ + "static/media/blackberry_jam.89a7f7a1.png";